import {IEventConfig} from '@mintdata/mint-kit/api/events/EventConfig';
import {EventSpec} from '@mintdata/mint-kit/api/events/EventSpec';
import {EventUtils} from '@mintdata/mint-kit/api/events/EventUtils';
import {PropName} from '@mintdata/mint-kit/api/properties/PropertySpec';

export function Event(spec:IEventConfig):PropertyDecorator
{
    return function(target:any, propName:PropName):void
    {
        let eventMap = EventUtils.getOrCreateEventMap(target);

        eventMap.add(new EventSpec(
            propName,
            spec.isEnabled === true,
            spec.title,
            spec.tip,
            spec.isHideOnPropertyPanel
        ));
    };
}
